export const LEGAL_PATHS = {
    terms: '/legal/terms',
    privacy: '/legal/privacy',
    communityGuidelines: '/legal/community-guidelines',
    cookies: '/legal/cookies',
    report: '/legal/report',
}
export const isLegalPath = pathname => pathname === '/legal' || pathname.startsWith('/legal/')
